import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=859d234a&"
import script from "./Transition.vue?vue&type=script&lang=js&"
export * from "./Transition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports